import React from "react";

export default function GlobalCard({ children }) {
  return (
    <div className="flex p-5 h-full w-full bg-white overflow-auto shadow-md rounded-md border border-slate-200 flex-col space-y-3">
      {children}
    </div>
  );
}
